import { useEffect, useState } from "react";
import './RegisterForm.scss';
import FilterRegisterForm from "./filter/FilterRegisterForm";
import ListRegisterForm from "./list/ListRegisterForm";
import { RegisterFormFieldsData } from "../../../../models/RegisterFormData";
import { RegisterFormFilterData } from '../../../../models/RegisterFormData';
import { fetchFilterFieldsRegisterForm, } from "../../../../api/repositoryEP";
import { CustomPagination } from "../../..";
import { NoData } from "../../../common";
import AddittionalConfigurationComponent from "./additionalConfiguration/AddittionalConfigurationComponent";
import { PageSize } from "../../../../utils/constants";

interface RegisterFormInterface {
    languages: string[];
}

const RegisterForm = (props: RegisterFormInterface): JSX.Element => {


    const languages = props.languages;
    const [fieldsList, setFieldList] = useState<RegisterFormFieldsData[]>([])
    const [searching, setSearching] = useState<boolean>(true);

    const [actualPage, setActualPage] = useState<number>(1);
    const [actualPageSize, setActualPageSize] = useState<number>(PageSize);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [actualFilter, setActualFilter] = useState<RegisterFormFilterData>({
        status: '',
        fieldType: '',
        label: '',
        language: '',
        nameField: '',
        page: 0,
        pageSize: PageSize,
    });

    const onChangePagination = (newPage: number, newPageSize?: number | undefined) => {
        setActualPage(newPage);
        setActualPageSize(newPageSize ?? PageSize);
        setActualFilter({
            ...actualFilter,
            page: newPage - 1,
            pageSize: newPageSize ?? PageSize
        });
    }

    const filterRegiterFormFields = async () => {
        setSearching(true);
        fetchFilterFieldsRegisterForm(actualFilter)
            .then((r) => {
                if (r?.type === 1) {
                    setFieldList(r?.data.elements as RegisterFormFieldsData[]);
                    setTotalRecords(r?.data.totalRecords as number);
                }
                setSearching(false);
            })
    };

    useEffect(() => {
        filterRegiterFormFields();
    }, [actualFilter])


  


    return (
        <div className="register-form-component ">
            <div className="filter-container">
                <AddittionalConfigurationComponent /> 
                <FilterRegisterForm
                    onSearch={setActualFilter}
                    searching={searching}
                    languages={languages}
                />

                <ListRegisterForm
                    list={fieldsList}
                    loading={searching}
                    languages={languages}
                    onSearch={setActualFilter}
                />

            </div>
            {!searching && (
                fieldsList.length === 0 ? (
                    <NoData />
                ) : (
                    <div className="pagination-container">
                        <CustomPagination
                            actualPage={actualPage}
                            actualPageSize={actualPageSize}
                            totalElements={totalRecords}
                            onChange={onChangePagination}
                        />
                    </div>
                )
            )}
        </div>
    );
};


export default RegisterForm;